// admin/src/App.tsx
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NoteForm from './pages/NoteForm';
import NoteList from './pages/NoteList';
import UserList from './pages/UserList';
import SaveUser from './pages/SaveUser';
import ProfilePage from './pages/ProfilePage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import Tunes from './pages/Tunes';
import PasswordGenerationLogs from './pages/PasswordGenerationLogs';
import InternetSpeedLogs from './pages/InternetSpeedLogs';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Protected (wrap all with Layout here) */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout><Dashboard /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout><Dashboard /></Layout>
            </ProtectedRoute>
          }
        />

        {/* Notes */}
        <Route
          path="/notes"
          element={
            <ProtectedRoute>
              <Layout><NoteList /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notes/create"
          element={
            <ProtectedRoute>
              <Layout><NoteForm /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notes/edit/:noteSlug"
          element={
            <ProtectedRoute>
              <Layout><NoteForm /></Layout>
            </ProtectedRoute>
          }
        />

        {/* Tunes */}
        <Route
          path="/tunes"
          element={
            <ProtectedRoute>
              <Layout><Tunes /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/password-generation"
          element={
            <ProtectedRoute>
              <Layout><PasswordGenerationLogs /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/internet-speed"
          element={
            <ProtectedRoute>
              <Layout><InternetSpeedLogs /></Layout>
            </ProtectedRoute>
          }
        />
        {/* Company-scoped nested resources */}

        {/* Users */}
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Layout><UserList /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/create"
          element={
            <ProtectedRoute>
              <Layout><SaveUser /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/edit/:id"
          element={
            <ProtectedRoute>
              <Layout><SaveUser /></Layout>
            </ProtectedRoute>
          }
        />

        {/* Profile */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout><ProfilePage /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/password"
          element={
            <ProtectedRoute>
              <Layout><ChangePasswordPage /></Layout>
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
